import { render, staticRenderFns } from "./PartsOfSpeechForm.vue?vue&type=template&id=579461c2&scoped=true&lang=pug&"
import script from "./PartsOfSpeechForm.vue?vue&type=script&lang=js&"
export * from "./PartsOfSpeechForm.vue?vue&type=script&lang=js&"
import style0 from "./PartsOfSpeechForm.vue?vue&type=style&index=0&id=579461c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579461c2",
  null
  
)

export default component.exports